import * as React from 'react';
import { createElement } from 'react';
import { Form, Radio, Input, Field, Message } from '@alifd/next';
import WorkflowActions from './components/workflow-actions';
import request from '@/utils/request';
import { workflowStore } from '@/store';
import { useLocalObservable, observer } from 'mobx-react';
import './index.scss';
import { isEmpty } from 'lodash-es';
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const OpinionForm = observer((props) => {
    const { setDocumentId, documentId, setDocListNbr, docListNbr, setDocumentPermissions } = useLocalObservable(() => workflowStore);
    const [commentOptions, setCommentOptions] = React.useState([]);
    const [operationOptions, setOperationOptions] = React.useState([]);
    const { getFormValues: __getFormValues, validateForms: __validateForms, __designMode, ctx: __ctx, status, ...otherProps } = props;
    const isDesign = __designMode === 'design';
    const isPreview = status === 'readonly';
    const fieldInstance = Field.useField();
    const { processType, type, formId, } = __ctx?.appHelper?.constants || {};
    const { tabhelper, } = __ctx?.appHelper?.utils || {};
    const initDocListId = React.useCallback(async () => {
        if (docListNbr) {
            const { content: { bizDocListId }, } = await request.post(`/api/document/bizDocListAndDetail/byDocListNbr?docListNbr=${docListNbr}`);
            setDocumentId(bizDocListId);
        }
    }, [docListNbr, setDocumentId]);
    const queryStartConfig = React.useCallback(async () => {
        const { content: { formConfig: { docListNbr = null, commentOptions = [], operationOptions = [] } = {}, documentPermissions = [], }, } = await request(`/api/process/firstNode/info/${processType}`);
        setCommentOptions(commentOptions);
        setOperationOptions(operationOptions);
        setDocListNbr(docListNbr);
        setDocumentPermissions(documentPermissions);
        initDocListId();
    }, [processType, setDocListNbr, setDocumentPermissions, initDocListId]);
    const queryDraftConfig = React.useCallback(async () => {
        const { content: { formConfig: { docListNbr = null, commentOptions = [], operationOptions = [] } = {}, documentPermissions = [], comment: _comment = {}, bizDocListId = null, } = {}, } = await request(`/api/process/form/draft/${formId}`, {
            params: {
                procCfgType: processType,
            },
        });
        setDocListNbr(docListNbr);
        if (isEmpty(bizDocListId)) {
            initDocListId();
        }
        else {
            setDocumentId(bizDocListId);
        }
        setCommentOptions(commentOptions);
        setOperationOptions(operationOptions);
        setDocumentPermissions(documentPermissions);
        fieldInstance.setValues(_comment);
    }, [
        fieldInstance,
        formId,
        processType,
        setDocListNbr,
        setDocumentId,
        setDocumentPermissions,
        initDocListId,
    ]);
    React.useEffect(() => {
        if (!isDesign) {
            if (type === 'create') {
                queryStartConfig();
            }
            else if (type === 'draft') {
                debugger;
                queryDraftConfig();
            }
        }
    }, [isDesign, queryDraftConfig, queryStartConfig, type]);
    const onChange = (value, items) => {
        const { name, field, value: currentFieldValue } = items;
        switch (name) {
            case 'opinion':
                field.setValue('comment', OpinionMap.find(({ value: v }) => currentFieldValue === v)?.label);
                break;
            default:
                break;
        }
    };
    const getFormValues = () => {
        const values = __getFormValues();
        return values;
    };
    const validateForms = async () => {
        return new Promise((resolve) => {
            __validateForms(async (err) => {
                if (err) {
                    resolve(false);
                }
                if (isEmpty(documentId)) {
                    Message.warning('请上传附件');
                    resolve(false);
                }
                const { content = [] } = await request.get(`/api/document/bizDocDetail/${documentId}`);
                if (content.length > 0) {
                    const isAttachmentUpload = content.some(item => (item?.custDocTypeInd === false || item?.custDocTypeInd === 'false') && isEmpty(item?.resDocPhyInfoDTO));
                    if (isAttachmentUpload) {
                        Message.warning('请上传附件');
                        resolve(false);
                    }
                    else {
                        resolve(true);
                    }
                }
                else {
                    resolve(true);
                }
            });
        });
    };
    return (createElement("div", { className: "opinion-container" },
        createElement(Form, { ...otherProps, useLabelForErrorMessage: true, onChange: onChange, field: fieldInstance, isPreview: isPreview },
            createElement(FormItem, { name: "opinion", label: "\u5E38\u7528\u5C97\u4F4D\u610F\u89C1" },
                createElement(RadioGroup, null, OpinionMap.filter(({ value }) => commentOptions?.find((v) => v === value)).map(({ label, value }) => (createElement(Radio, { key: value, value: value }, label))))),
            createElement(FormItem, { name: "comment", label: "\u5C97\u4F4D\u610F\u89C1", required: true },
                createElement(Input.TextArea, null))),
        createElement("div", { className: "actions-wrap" },
            createElement(WorkflowActions, { operationOptions: operationOptions, opinionFormInstance: fieldInstance, validateForms: validateForms, getFormValues: getFormValues, processType: processType, formId: formId, tabhelper: tabhelper }))));
});
OpinionForm.displayName = 'OpinionForm';
export default OpinionForm;
const OpinionMap = [
    {
        label: '同意',
        value: 'AGREE',
    },
    {
        label: '有条件同意',
        value: 'CONDITIONAL_AGREE',
    },
    {
        label: '不同意',
        value: 'DISAGREE',
    },
    {
        label: '再议',
        value: 'RECONSIDER',
    },
];
